/**
 * User Query Keys
 *
 * Centralized query key factory for React Query cache management
 * Following React Query best practices for key management
 */

import type { UserListParams } from '../types/user.types';

export const userQueryKeys = {
  // Base key for all user-related queries
  all: ['users'] as const,

  // List queries
  lists: () => [...userQueryKeys.all, 'list'] as const,
  list: (params?: UserListParams) =>
    [...userQueryKeys.lists(), params] as const,

  // Other users list (no pagination support)
  otherUsers: () => [...userQueryKeys.all, 'other-users'] as const,

  // Detail queries
  details: () => [...userQueryKeys.all, 'detail'] as const,
  detail: (id: string) => [...userQueryKeys.details(), id] as const,
};

